import TomSelect from 'tom-select';

export function initSelects(sortOptions = []) {
	const selectElements = document.querySelectorAll('.select:not(.custom-initialized)');

	selectElements.forEach((selectWrapper) => {
		let select = selectWrapper.querySelector('.select__el');
		if (select) {
			new TomSelect(select, {
				// Disable text input so the control behaves like a native dropdown
				create: false,
				controlInput: null,
				searchField: [],
				sortField: sortOptions
			});
		}
	});
}
